import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';

export const AdminBreadcrumbResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const userId = route.paramMap.get('id');
  return userId ? userId : '0';
};
